import React from "react";

import "./TermsAndConditions.css";

function PrivacyAndPolicy() {
  

  return (
    <div className="TermsAndConditions">
      <div className="tc-container">
        <h1>Privacy Policy</h1>

        <p>
          ISBC built the ISBC app as a Free app. This SERVICE is provided by
          ISBC at no cost and is intended for use as is. <br />
          This page is used to inform visitors regarding my policies with the
          collection, use, and disclosure of Personal Information if anyone
          decided to use my Service. <br /> If you choose to use our Service,
          then you agree to the collection and use of information in relation to
          this policy and comply with and be bound by the following terms and
          conditions of use, which together with our privacy policy govern
          ISBC(INDIAN SCHOOLS BOARD FOR CRICKET’s ) relationship with you in
          relation to this app. The Personal Information that I collect is used
          for providing and improving the Service. I will not use or share your
          information with anyone except as described in this Privacy Policy.
          <br />
          The term ISBC and ‘INDIAN SCHOOLS BOARD FOR CRICKET’ or ‘us’ or ‘we’
          refers to the owner of the Application whose registered office is
          4-1-122/2, 1st Floor, Mahakali Street, Hyderabad. Hyderabad TELANGANA
          500009 and operational office is 3-6-475/A, Above HDFC Bank,
          Kalpavruksha, First Floor, Himayath nagar, Hyderabad – 500027. The
          term ‘you’ refers to the user or viewer of our website. Your use
          constitutes acceptance of these terms and conditions as at the date of
          your first use of the app. ISBC reserves the right to change these
          terms and conditions at any time by posting changes online. Your
          continued use of this app after changes are posted constitutes your
          acceptance of this agreement as modified. You agree to use this app
          only for lawful purposes, and in a manner which does not infringe the
          rights, or restrict, or inhibit the use and enjoyment of the app by
          any third party.
          <br />
          Information, names, images, pictures, logos regarding or relating to
          ISBC are provided “as is” without any representation or endorsement
          made and without warranty of any kind whether express or implied. In
          no event will ISBC be liable for any damages including, without
          limitation, indirect or consequential damages, or any damages
          whatsoever arising from the use or in connection with such use or loss
          of use of the site, whether in contract or in negligence. <br />
          The terms used in this Privacy Policy have the same meanings as in our
          Terms and Conditions, which are accessible at ISBC unless otherwise
          defined in this Privacy Policy.
        </p><br/>
        <h3>Information Collection and Use: </h3>
        <p>
          {" "}
          For a better experience, while using our Service, We may require you
          to provide us with certain personally identifiable information,
          including but not limited to name, phone number, email address. The
          information that we request will be retained on your device and is not
          collected by me in any way. This site and the information, names,
          images, pictures, logos regarding or relating to ISBC are provided “as
          is” without any representation or endorsement made and without
          warranty of any kind whether express or implied. In no event will ISBC
          be liable for any damages including, without limitation, indirect or
          consequential damages, or any damages whatsoever arising from the use
          or in connection with such use or loss of use of the site, whether in
          contract or in negligence.{" "}
        </p>
        <br />
        <h3>Log Data:</h3>
        <p>
          {" "}
          We want to inform you that whenever you use my Service, in a case of
          an error in the app we collect data and information (through
          third-party products) on your phone called Log Data. This Log Data may
          include information such as your device Internet Protocol (“IP”)
          address, device name, operating system version, the configuration of
          the app when utilizing my Service, the time and date of your use of
          the Service, and other statistics.{" "}
        </p>
        <br />
        <h3>Cookies: </h3>
        <p>
          Cookies are files with a small amount of data that are commonly used
          as anonymous unique identifiers. These are sent to your browser from
          the websites that you visit and are stored on your device's internal
          memory. <br /> This Service does not use these “cookies” explicitly.
          However, the app may use third-party code and libraries that use
          “cookies” to collect information and improve their services. You have
          the option to either accept or refuse these cookies and know when a
          cookie is being sent to your device. If you choose to refuse our
          cookies, you may not be able to use some portions of this Service.{" "}
        </p><br/>
        <h3>Service Providers: </h3>
        <h4>
          We may employ third-party companies and individuals due to the
          following reasons:{" "}
        </h4>
        <p>
          To facilitate our Service; <br />
          To provide the Service on our behalf; <br />
          To perform Service-related services; or <br />
          To assist us in analyzing how our Service is used. <br />
          We want to inform users of this Service that these third parties have
          access to their Personal Information. The reason is to perform the
          tasks assigned to them on our behalf. However, they are obligated not
          to disclose or use the information for any other purpose.{" "}
        </p>
        <br />
        <h3>Security: </h3>
        <p>
          We value your trust in providing us your Personal Information, thus we
          are striving to use commercially acceptable means of protecting it.
          But remember that no method of transmission over the internet, or
          method of electronic storage is 100% secure and reliable, and We
          cannot guarantee its absolute security.{" "}
        </p><br/>
        <h3>Links to Other Sites: </h3>
   
        <p>
          This Service may contain links to other sites. If you click on a
          third-party link, you will be directed to that site. Note that these
          external sites are not operated by me. Therefore, We strongly advise
          you to review the Privacy Policy of these websites. We have no control
          over and assume no responsibility for the content, privacy policies,
          or practices of any third-party sites or services.{" "}
        </p>
        <br />
        <h3>Children’s Privacy: </h3>
        <p>
          We do not knowingly collect personally identifiable information from
          children. We encourage all children to never submit any personally
          identifiable information through the Application and/or Services. We
          encourage parents and legal guardians to monitor their children's
          Internet usage and to help enforce this Policy by instructing their
          children never to provide personally identifiable information through
          the Application and/or Services without their permission. If you have
          reason to believe that a child has provided personally identifiable
          information to us through the Application and/or Services, please
          contact us. You must also be at least 16 years of age to consent to
          the processing of your personally identifiable information in your
          country (in some countries we may allow your parent or guardian to do
          so on your behalf).{" "}
        </p><br/>
        <h3>Changes to This Privacy Policy: </h3>
        <p>
          We may update our Privacy Policy from time to time. Thus, you are
          advised to review this page periodically for any changes. We will
          notify you of any changes by posting the new Privacy Policy on this
          page.{" "}
        </p>
        <br />
        <p>This policy is effective as of 19-06-2023 </p>
        <br />
        <h3>Contact Us: </h3>
        <p>
          If you have any questions or suggestions about my Privacy Policy, do
          not hesitate to contact Us at. isbccricket@gmail.com.
        </p>
      </div>
    </div>
  );
}

export default PrivacyAndPolicy;
